import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { HD, FULL_HD, safetyMargins } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { middle, SCREEN_WIDTH, SCREEN_HEIGHT } from '../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const getContentPadding = (screenSize = undefined) => {
  const screenDimension = screenSize || defaultContext.screenSize;

  return safetyMargins.horizontal[screenDimension];
};

export const CONTENT_GAP = {
  [HD]: 40,
  [FULL_HD]: 40,
};

export const WIDTH = {
  ...SCREEN_WIDTH,
};

export const LOGO_HEIGHT = {
  [HD]: 128,
  [FULL_HD]: 152,
};

export const LOGO_Y = {
  [HD]: 88,
  [FULL_HD]: 104,
};

export const TITLE_MARGIN_BOTTOM = {
  [HD]: 40,
  [FULL_HD]: 96,
};

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const w = WIDTH[screenSize];
  const h = SCREEN_HEIGHT[screenSize];

  const titleY = LOGO_Y[screenSize] + LOGO_HEIGHT[screenSize];
  const titleFont = getFont(FONT.PARIS_3, screenSize);

  return {
    w,
    h,
    alpha: 0,
    Background: {
      w,
      h,
      color: colors.background[colorMode],
    },
    CustomerLogo: {
      mountX: 0.5,
      x: middle,
      y: LOGO_Y[screenSize],
      h: LOGO_HEIGHT[screenSize],
    },
    Title: {
      mountX: 0.5,
      x: Math.round(w / 2),
      y: titleY,
      text: titleFont,
    },
    Blocks: {
      y: titleY + titleFont.lineHeight + TITLE_MARGIN_BOTTOM[screenSize],
      w,
    },
  };
};
